import { z } from 'zod';
import i18n from '@/shared/i18n/i18n';

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"|,.<>?]).{8,}$/;

const createPasswordSchema = z
  .object({
    password: z
      .string()
      .nonempty(i18n.t('createPassword.errors.password'))
      .regex(passwordRegex, i18n.t('createPassword.errors.format')),
    confirmPassword: z
      .string()
      .nonempty(i18n.t('createPassword.errors.passwordConfirm')),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: i18n.t('createPassword.errors.passwordMatch'),
    path: ['confirmPassword'],
  });

type CreatePasswordFormValues = z.infer<typeof createPasswordSchema>;

export { createPasswordSchema, type CreatePasswordFormValues };
